import { useNavigate } from "react-router-dom";
import useAppState from "../../../context/AppContext";
import { APP_RETIREMENT_URLS } from "../../../const/AppConst";
import StickButtonsBloc from "../../common/StickButtonsBloc";
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import IdentityTemplateFormComponent, { IdentityTemplateFormData, validationSchemaIdentityTemplate } from "../../../components/info-perso-template/IdentityTemplateFormComponent";
import GeneralDataProtectionBloc from "../../common/GeneralDataProtectionBloc";


export default function REInfoIdentityBloc() {

  const navigate = useNavigate();
  const {
    state: { updatedProposition, proposition },
    dispatch
  } = useAppState();

  const {
    register, 
    setValue,
    watch,
    handleSubmit,
    formState: { errors },
  } = useForm<IdentityTemplateFormData>({
    mode: "onBlur",
    reValidateMode: "onChange",
    defaultValues: {
      familySituationCode: updatedProposition?.familySituationCode ? updatedProposition?.familySituationCode : '',
      birthPlace: updatedProposition?.birthPlace ? updatedProposition.birthPlace : "",
      civilityCode: updatedProposition?.civilityCode ? updatedProposition?.civilityCode : '',
      firstName: updatedProposition?.firstName ? updatedProposition?.firstName : '',
      lastName: updatedProposition?.lastName ? updatedProposition?.lastName : '',
      birthDate: updatedProposition?.birthDate ? updatedProposition?.birthDate : '',
      birthName: updatedProposition?.birthName ? updatedProposition?.birthName : '',
    },
    resolver: yupResolver(validationSchemaIdentityTemplate),
  });

  const onNextAction = async (data: IdentityTemplateFormData) => {
   
    let tempUpdatedPropo = updatedProposition;
    if(tempUpdatedPropo) {
      tempUpdatedPropo.familySituationCode = data.familySituationCode;
      tempUpdatedPropo.birthPlace = data.birthPlace;
      tempUpdatedPropo.civilityCode = data.civilityCode;
      tempUpdatedPropo.firstName = data.firstName.replaceAll("'", " ");
      tempUpdatedPropo.lastName = data.lastName.replaceAll("'", " ");
      tempUpdatedPropo.birthDate = data.birthDate;
      tempUpdatedPropo.birthName = data.birthName.replaceAll("'", " ");
    }
    const nextUrl = APP_RETIREMENT_URLS.infoAddressPage;
    dispatch({type: 'NEXT_INFO_STEP', path: nextUrl, updatedProposition: tempUpdatedPropo});
    navigate({
        pathname: nextUrl,
        search: `?id=${proposition!.propositionId}`,
    });  

  }

  const onPreviousAction = async () => {
    const url = APP_RETIREMENT_URLS.guarantyPage
   
    dispatch({type: 'BACK_INFO_STEP', path: url});
    navigate({
        pathname: url,
        search: `?id=${proposition!.propositionId}`,
    });         
  }


  return (
    <form style={{width: '100%'}}>
      <div className='form-row page-content'>
        <IdentityTemplateFormComponent 
            register={register} 
            setValue={setValue} 
            watch={watch}
            errors={errors} />
      </div>
      <StickButtonsBloc 
        showPreviousButton={true} 
        disabledPreviousButton={false} 
        nextAction={handleSubmit(onNextAction)} 
        showNextButton={true} 
        previousAction={onPreviousAction}
      />
      <GeneralDataProtectionBloc/>
      
    </form>
  )
}